import { motion } from 'framer-motion';
import type { ReactNode } from 'react';

export default function PageMotion({ children }: { children: ReactNode }) {
  return (
    <motion.div
      className="page-motion"
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -5 }}
      transition={{ duration: 0.22, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}
